import { Container, CssBaseline } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { gateway } from "../gateway";
import {
  nextViewConnectBusinessState,
  previousViewConnectBusinessState,
  updateConnectBusinessState,
} from "../redux/features/connectBusinessStateSlice";
import { nextViewSignupBusinessState, updateSignupBusinessState } from "../redux/features/signupBusinessStateSlice";
import { updateUser } from "../redux/features/userStateSlice";
import { ConnectBusinessAddress } from "./connectBusinessAddress";
import { ConnectBusinessCommercial } from "./connectBusinessCommercial";
import { ConnectBusinessExpandYesEmployees } from "./connectBusinessExpandYesEmployees";
import { ConnectBusinessRequirements } from "./connectBusinessRequirements";
import { ConnectBusinessResidential } from "./connectBusinessResidential";
import { ConnectBusinessSearch } from "./connectBusinessSearch";
import { ConnectBusinessTypeOfJob } from "./connectBusinessTypeOfJob";
import { ConnectEmployeeTres } from "./connectEmployeeTres";
import { connectBusinessFlowColors } from "./connectBusinessFlowStyles";

export const ConnectBusinessAlgorithm = () => {
  const [isFormValid, setIsFormValid] = useState(false);
  const connectBusinessState = useSelector((state) => state.connectBusinessState);
  const { serviceType } = connectBusinessState;

  const dispatch = useDispatch();
  const currPage = "/signupBusiness";
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const token = sessionStorage.getItem("token");

  const { residentialServices: checkedResidentialService } = connectBusinessState;
  const { commercialServices: checkedCommercialServices } = connectBusinessState;
  const { requirements: checkedRequirements } = connectBusinessState;

  const [isVisible, setIsVisible] = useState(false);

  const [isUserCreated, setIsUserCreated] = useState(false);

  const { currentView } = connectBusinessState;

  useEffect(() => {
    if (!connectBusinessState.isDemo) {
      handleFindACleaner();
    }
    // Simula un retraso de 1 segundo antes de mostrar el contenido
    const timeout = setTimeout(() => {
      setIsVisible(true);
    }, 200);
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true); // Mostrar el Loader
    setOpen(true); // Abrir el diálogo
    dispatch(updateSignupBusinessState());
    dispatch(nextViewSignupBusinessState());
    setIsLoading(false);
    setOpen(false);
  };

  const handleFindACleaner = async () => {
    // get the current user benefits
    await gateway
      .get("/paypal/subscriptions-self", {
        headers: {
          Authorization: `${token}`,
        },
      })
      .then((res) => {
        const data = res.data.data;
        dispatch(
          updateUser({
            subscription: data?.subscription?.id
              ? {
                id: data?.subscription?.id,
                paypalSubscriptionId: data?.subscription?.paypalId,
                planName: data?.subscription?.plan?.product?.name,
                planId: data?.subscription?.plan?.id,
                planPaypalId: data?.subscription?.plan?.paypalPlanId,
                hexColor: data?.subscription?.plan?.product?.hexColor,
                createdAt: data?.subscription?.createdAt,
              }
              : null,

            benefits: data?.benefits ?? [],
          }),
        );
      });
  };

  const renderServiceTypeComponent = () => {
    switch (serviceType) {
      case "residential":
        return (
          <ConnectBusinessResidential
            checkedState={checkedResidentialService}
            nextViewComponentState={nextViewConnectBusinessState}
            previousViewEntityState={previousViewConnectBusinessState}
            updateComponentState={updateConnectBusinessState}
          />
        );
      case "commercial":
        return (
          <ConnectBusinessCommercial
            checkedState={checkedCommercialServices}
            nextViewComponentState={nextViewConnectBusinessState}
            previousViewEntityState={previousViewConnectBusinessState}
            updateComponentState={updateConnectBusinessState}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Container
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--fx-surface-sunken, #F8FAFC)",
        height: "100%",
        margin: "auto",
        minWidth: { xs: "100%", md: 600 },
        px: { xs: 0, md: 1 },
      }}
    >
      <CssBaseline />
      {/*currentView === 0 && <ConnectBusinessWelcomeMessage />*/}
      {currentView === 0 && <ConnectBusinessTypeOfJob />}
      {currentView === 1 && <ConnectBusinessAddress updateComponentState={updateConnectBusinessState} />}
      {currentView === 2 && <ConnectBusinessSearch />}
      {/* {currentView === 4 && (
        <ConnectBusinessExpandNoEmployees />
      )} */}
      {currentView === 3 && <ConnectBusinessExpandYesEmployees />}
      {currentView === 4 && renderServiceTypeComponent()}
      {currentView === 5 && (
        <ConnectBusinessRequirements
          checkedState={checkedRequirements}
          nextViewComponentState={nextViewConnectBusinessState}
          previousViewEntityState={previousViewConnectBusinessState}
          updateComponentState={updateConnectBusinessState}
        />
      )}
      {currentView === 6 && (
        <ConnectEmployeeTres
          checkedState={checkedRequirements}
          nextViewComponentState={nextViewConnectBusinessState}
          previousViewEntityState={previousViewConnectBusinessState}
          updateComponentState={updateConnectBusinessState}
        />
      )}
    </Container>
  );
};
